export * from "./update-dataset-value"
export * from "./with-props-validation"

/**
 * Defer importing a def view function until it's called
 *
 * There are some limitations in webpack around dynamic expressions, and so we
 * need to have the view base be a known path like `../`
 *
 * https://webpack.js.org/guides/migrating/#dynamic-expressions
 *
 * @param {String} path Path to view module (relative to entry root)
 */

function importDeferredView(path) {
  return (el, props) => {
    return import(`../${path}/index.ts`).then(f => f.default(el, props))
  }
}
function importDeferredViewTsx(path) {
  return (el, props) => {
    return import(`../${path}/index.tsx`).then(f => f.default(el, props))
  }
}

export default {
  lazyLoad: importDeferredView("lazy-load"),
  masthead: importDeferredView("masthead"),
  componentLibraryMasthead: importDeferredView("component-library-masthead"),
  backgroundVideoControls: importDeferredView("background-video-controls"),
  companyValuesList: importDeferredView("company-values-list"),
  backgroundColorChangeOnScroll: importDeferredView(
    "background-color-change-on-scroll"
  ),
  podcastEpisodeToggle: importDeferredView("podcast-episode-toggle"),
  salesToggle: importDeferredView("sales-toggle"),
  podcastSubscribeToggle: importDeferredView("podcast-subscribe-toggle"),
  news: importDeferredView("news"),
  newAndNoteworthy: importDeferredView("new-and-noteworthy"),
  toggleFromList: importDeferredView("toggle-from-list"),
  customerList: importDeferredView("customer-list"),
  testimonialCarousel: importDeferredView("testimonial-carousel"),
  tabs: importDeferredView("tabs"),
  productBlock: importDeferredView("product-block"),
  careersListing: importDeferredView("careers-listing"),
  collectionToggle: importDeferredView("collection-toggle"),
  filters: importDeferredView("filters"),
  localizedDateTime: importDeferredView("localized-date-time"),
  pricingTable: importDeferredView("pricing-table"),
  horizontalScrollControl: importDeferredView("horizontal-scroll-control"),
  collapsible: importDeferredView("collapsible"),
  logoSetRows: importDeferredView("logo-set-rows"),
  dropdown: importDeferredView("dropdown"),
  videoModal: importDeferredView("video-modal"),
  ribbon: importDeferredView("ribbon"),
  cookieRibbon: importDeferredView("cookie-ribbon"),
  componentLibraryMasthead: importDeferredView("component-library-masthead"),
  articlesSearch: importDeferredViewTsx("articles-search")
}
